import { axiosInstance } from "api/axios-config/axios-config";
import { BaseRequest } from "api/models/request/base-request";
import { Pagination } from "api/models/response/pagination";

export class BaseBussiness<T, addT, updateT, TDetail> {
  _url: string = "";
  constructor(url: string) {
    this._url = url;
  }

  public getLists = async <TRequest = BaseRequest>(
    request: TRequest,
    url?: string
  ) => {
    try {
      url = url ? url : this._url;
      var res = await axiosInstance.get<Pagination<T>>(url, {
        params: request,
      });
      return res.data;
    } catch (error) {
      console.error("Fail get lists", error);
      return Promise.reject(error);
    }
  };

  public add = async (add: addT) => {
    try {
      var res = await axiosInstance.post<T | string>(this._url, add);
      return res.data;
    } catch (error) {
      console.error("Fail add data", error);
      return Promise.reject(error);
    }
  };

  public getById = async (id: string) => {
    try {
      var res = await axiosInstance.get<TDetail>(`${this._url}/${id}`);
      return res.data;
    } catch (error) {
      console.error("Fail ", error);
      return Promise.reject(error);
    }
  };

  public update = async (id: string, update: updateT) => {
    try {
      var res = await axiosInstance.put<T | string>(
        `${this._url}/${id}`,
        update
      );
      return res.data;
    } catch (error) {
      console.error("Fail update", error);
      return Promise.reject(error);
    }
  };

  public delete = async (id: string) => {
    try {
      var res = await axiosInstance.delete(`${this._url}/${id}`);
      return res.data;
    } catch (error) {
      console.error("Fail delete", error);
      return Promise.reject(error);
    }
  };
}
